export const faqs = [
  {
    question: "O que a Restituir faz?",
    answer:
      "Nós ajudamos empresas a recuperar impostos pagos a mais e a corrigir o cadastro de produtos, garantindo que você pague apenas o que é devido.",
  },
  {
    question: "Esse processo é seguro?",
    answer: "Sim. Todo o trabalho é feito de forma administrativa, dentro da lei e com base em documentação oficial.",
  },
  {
    question: "Preciso trocar de contador para usar os serviços da Restituir?",
    answer:
      "Não. Você mantém o seu contador. Nós apenas atuamos de forma complementar, entregando relatórios e informações para facilitar o trabalho dele.",
  },
  {
    question: "Quais empresas podem se beneficiar?",
    answer:
      "Principalmente empresas do Simples Nacional, mas também atendemos Lucro Real e Presumido. Os segmentos mais comuns são: autopeças, farmácias, bares, restaurantes, mercados, distribuidoras, padarias, petshops e outros.",
  },
  {
    question: "Como funciona a recuperação de impostos?",
    answer:
      "Analisamos suas notas fiscais, identificamos pagamentos feitos a maior e solicitamos a restituição diretamente na Receita Federal.",
  },
  {
    question: "Existe risco de multa ou problema com a Receita?",
    answer: "Não. Como atuamos dentro da legalidade e de forma administrativa, não há risco de autuações ou multas.",
  },
  {
    question: "Além da recuperação, quais serviços vocês oferecem?",
    answer:
      "• Auditoria de cadastro de produtos – corrigimos erros no sistema para evitar pagamentos indevidos.\n• Monitoramento de mercadorias – ajustes mensais para manter o cadastro atualizado.\n• Monitoramento tributário – análise mensal para aplicar descontos já no imposto do mês seguinte.",
  },
  {
    question: "Como posso contratar os serviços?",
    answer:
      "Basta entrar em contato pelo WhatsApp, telefone ou e-mail. Nossa equipe faz um diagnóstico inicial sem custo.",
  },
];
